import React from 'react'

function AvatarSuccessfulPopup({ setGetResponse, resMessage }) {
    return (
        <div className=" successful_create_transprant_body">
            <div className=" p-2 successful_create_container shadow">
                {resMessage.status === true ?
                    (<div>
                        <img src="images/Ellipse 208.svg" alt="" style={{ marginLeft: "100px" }} />
                        <span className=" my-4 successfully_create_message">
                            {resMessage.message}
                        </span>
                    </div>) : (
                        <div>
                            <img src="/images/alert.svg" alt="" style={{ marginLeft: "160px" }} />
                            <span className=" my-4 successfully_create_message">
                                {resMessage.message}
                            </span>
                        </div>
                    )
                }
                <button
                    onClick={() => {
                        setGetResponse(false)
                    }}
                    className="btn btn-danger px-4 py-2 successfull_create_okay_btn"
                >
                    Okay

                </button>
            </div>
        </div>
    )
}

export default AvatarSuccessfulPopup